// Define keyframes for color animation
const colorShiftKeyframes = `
@keyframes color-shift {
  0% {
    filter: drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.25)) brightness(1) saturate(200%) sepia(100%) hue-rotate(200deg); /* Berkeley Blue */
  }
  25% {
    filter: drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.25)) brightness(1.3) saturate(150%) sepia(100%) hue-rotate(320deg); /* California Gold */
  }
  50% {
    filter: drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.25)) brightness(2) saturate(0%) sepia(0%); /* White */
  }
  75% {
    filter: drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.25)) brightness(0) saturate(0%); /* Black */
  }
  100% {
    filter: drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.25)) brightness(1) saturate(200%) sepia(100%) hue-rotate(200deg); /* Berkeley Blue */
  }
}
`;

// Add style tag to head
if (!document.getElementById('color-shift-keyframes')) {
  const styleSheet = document.createElement('style');
  styleSheet.id = 'color-shift-keyframes';
  styleSheet.textContent = colorShiftKeyframes;
  document.head.appendChild(styleSheet);
}

export const heroLogo = (
  <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
    <img 
      src="/media/cbc/cbc_white.svg" 
      alt="CBC Logo" 
      style={{
        maxWidth: '436px',
        display: 'block',
        margin: '0 auto',
        animation: 'color-shift 20s ease-in-out infinite',
        transition: 'all 0.3s ease-in-out',
      }}
    />
  </div>
);

export const virtiusV = (
  <svg width={192} height={192} viewBox="0 0 512 512">
    <path
      d="M217.668 439.078h72.7L424 72.486h-74.748L270.4 293.158l-14.336 47.1h-4.1l-13.312-47.1-75.768-220.672H88.132z"
      fill="#00a2ff"
      fillRule="evenodd"
    />
  </svg>
);
